function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 7.81V12h-6.25V2h.44C19.83 2 22 4.17 22 7.81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 12v4.19c0 3.64-2.17 5.81-5.81 5.81h-.44V12H22zM8.25 12v10h-.44C4.17 22 2 19.83 2 16.19V12h6.25z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M7.81 2C4.17 2 2 4.17 2 7.81V12h6.25V2h-.44z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.75 2h-7.5v10h7.5V2z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M15.75 12h-7.5v10h7.5V12z"
})));